import { Text } from '@yes.technology/react-toolkit'
import { TextSliderCard as TextSliderCardContainer } from './TextSlider.styles'
import { TextSliderObject } from './TextSlider.types'

const TextSliderCard = ({
  des,
  complement,
  obs,
  headerVariant = 'bordertext-05',
  headerColor = '#a39999',
  descriptionVariant = 'content-emphasis-07',
  descriptionColor = '#303032',
  contentVariant = 'content-06',
  contentColor = '#303032'
}: TextSliderObject) => {
  return (
    <TextSliderCardContainer>
      <Text as='header' variant={headerVariant} style={{ color: headerColor }}>
        {obs}
      </Text>
      <Text
        as='h2'
        variant={descriptionVariant}
        style={{ color: descriptionColor }}
      >
        {des}
      </Text>
      {complement && (
        <Text as='p' variant={contentVariant} style={{ color: contentColor }}>
          {complement}
        </Text>
      )}
    </TextSliderCardContainer>
  )
}

export default TextSliderCard
